function throttle(callback, delay = 15) {
	let pause = false;
	let storedEvent = null;
	const throttledEventHandler = (event) => {
		storedEvent = event;
		if (!pause) {
			callback(storedEvent);
			storedEvent = null;
			pause = setTimeout(() => {
				pause = false;
				if (storedEvent) {
					throttledEventHandler(storedEvent);
				}
			}, delay);
		}
	};
	return throttledEventHandler;
}
class ReadProgressBar extends HTMLElement {
	connectedCallback() {
		this._init();
		this._updateReadingTime();
		this._setTopPosition();
		window.addEventListener('scroll', throttle(this._updateProgressBar.bind(this), 15));
		window.addEventListener('resize', throttle(this._setTopPosition.bind(this), 15));
	}
	_init() {
		this.stickyHeader = document.querySelector('sticky-header');
		this.articleSections = Array.from(document.querySelectorAll('[words-count]'));
		this.firstSection = this.articleSections[0];
		this.lastSection = this.articleSections[this.articleSections.length - 1];
		this.contentHeight =
			this.lastSection.getBoundingClientRect().bottom - this.firstSection.getBoundingClientRect().top;
	}
	_setTopPosition() {
		this.headerOffset = this.stickyHeader ? Math.floor(this.stickyHeader.getBoundingClientRect().height) : 0;
		this.style.setProperty('--top', `${this.headerOffset}px`);
	}
	_updateProgressBar() {
		const headerOffset = !this?.stickyHeader?.isHidden ? this.headerOffset : 0;
		const shouldReveal =
			this.firstSection.getBoundingClientRect().top < headerOffset && this.lastSection.getBoundingClientRect().bottom > 0;
		const endingPosition = this.lastSection.getBoundingClientRect().bottom;
		const difference = endingPosition - this.getBoundingClientRect().bottom;
		const progress = Math.max(0, Math.min(1, 1 - difference / this.contentHeight));
		this.style.setProperty('--progress', `${progress}`);
		this.classList.toggle('is-active', shouldReveal);
		return;
	}
	_updateReadingTime() {
		const readingTime = this.articleSections.reduce((acc, section) => {
			return acc + parseInt(section.getAttribute('words-count'));
		}, 0);
		const readingTimeInMinutes = Math.ceil(readingTime / 200);
		this.querySelector('[reading-time]').innerHTML = `${readingTimeInMinutes} min`;
	}
}
window.customElements.define('read-progress-bar', ReadProgressBar);
